import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const RefreshCW = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.25 21V16C2.25 15.5858 2.58579 15.25 3 15.25H8C8.41421 15.25 8.75 15.5858 8.75 16C8.75 16.4142 8.41421 16.75 8 16.75H4.81055L5.78125 17.7207L6.10059 18.0146C7.72948 19.4441 9.82413 20.2404 12.001 20.249C14.1887 20.2488 16.287 19.3809 17.834 17.834C19.3812 16.2868 20.25 14.188 20.25 12C20.25 11.5858 20.5858 11.25 21 11.25C21.4142 11.25 21.75 11.5858 21.75 12C21.75 14.5859 20.723 17.0661 18.8945 18.8945C17.0661 20.723 14.5859 21.75 12 21.75H11.9971C9.28752 21.7398 6.68638 20.6821 4.73828 18.7988L3.75 17.8105V21C3.75 21.4142 3.41421 21.75 3 21.75C2.58579 21.75 2.25 21.4142 2.25 21ZM2.25 12C2.25 9.41414 3.27699 6.93395 5.10547 5.10547C6.93395 3.27699 9.41414 2.25 12 2.25H12.0029L12.5098 2.26367C14.8668 2.38642 17.1146 3.30064 18.8887 4.85742L19.2617 5.20117L20.25 6.18945V3C20.25 2.58579 20.5858 2.25 21 2.25C21.4142 2.25 21.75 2.58579 21.75 3V8C21.75 8.41421 21.4142 8.75 21 8.75H16C15.5858 8.75 15.25 8.41421 15.25 8C15.25 7.58579 15.5858 7.25 16 7.25H19.1895L18.2188 6.2793L17.8994 5.98535C16.2703 4.55565 14.1752 3.7584 11.998 3.75C9.81072 3.75052 7.71273 4.6193 6.16602 6.16602C4.61884 7.71319 3.75 9.81196 3.75 12C3.75 12.4142 3.41421 12.75 3 12.75C2.58579 12.75 2.25 12.4142 2.25 12Z"
        fill={color}
      />
    </svg>
  )
}
